import { useSyncExternalStore } from 'react';

import type { Mindset } from '@/types';

// Tiny shared store so the mindset picker (Home) and the page background (Layout)
// can coordinate without prop drilling: the picker announces what was just chosen
// and the background reports whether the new image is still loading.
interface MindsetBackgroundState {
  isLoading: boolean;
  requested: Mindset | null;
}

let state: MindsetBackgroundState = { isLoading: false, requested: null };
const listeners = new Set<() => void>();

const update = (next: Partial<MindsetBackgroundState>) => {
  state = { ...state, ...next };
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const requestMindsetBackground = (requested: Mindset | null) =>
  update({ requested });

export const setMindsetBackgroundLoading = (isLoading: boolean) => {
  if (state.isLoading !== isLoading) update({ isLoading });
};

export const useMindsetBackgroundState = () =>
  useSyncExternalStore(subscribe, () => state);
